import { render, staticRenderFns } from "./messages.vue?vue&type=template&id=7efe6e07&scoped=true"
import script from "./messages.vue?vue&type=script&lang=js"
export * from "./messages.vue?vue&type=script&lang=js"
import style0 from "./messages.vue?vue&type=style&index=0&id=7efe6e07&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7efe6e07",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7efe6e07')) {
      api.createRecord('7efe6e07', component.options)
    } else {
      api.reload('7efe6e07', component.options)
    }
    module.hot.accept("./messages.vue?vue&type=template&id=7efe6e07&scoped=true", function () {
      api.rerender('7efe6e07', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aiSession/messages.vue"
export default component.exports